module.exports = __webpack_public_path__ + "img/time_square.88cd6c7c.svg";